import { URL_ORIGIN } from "@config/MetaTagsConstants";
import type { GADataProps } from "@elements/GAData/GAData";
import type { MetaTagsProps } from "@elements/MetaTags/MetaTags";
import type { KeywordMetaDataProps } from "@pages/Keyword/KeywordMetaData";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export function GeMetaData({
  tagName,
}: KeywordMetaDataProps): PageMetaDataValues {
  const metaTitle =
    "GE2025: சிங்கப்பூர் பொதுத் தேர்தல் தொடர்பான செய்திகளும் அண்மைய தகவல்களும் | தமிழ் முரசு";
  const metaDescription =
    "சிங்கப்பூர் பொதுத் தேர்தல் 2025 குறித்த அண்மைய செய்திகள், காணொளிகள், ஆழமான பகுப்பாய்வுகளை இங்கே காணலாம். அண்மைய தகவல்களுக்குத் தொடர்ந்து இணைந்திருங்கள்.";

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: metaTitle,
    startDate: "2025-04-14T13:00:00+08:00",
    location: {
      "@type": "Place",
      name: "Singapore",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Singapore",
      },
    },
    description:
      "சிங்கப்பூர் பொதுத் தேர்தல் 2025 குறித்த அண்மைய செய்திகள், காணொளிகள், ஆழமான பகுப்பாய்வுகளை இங்கே காணலாம். அண்மைய தகவல்களுக்குத் தொடர்ந்து இணைந்திருங்கள்.",
  };

  const metaTags: MetaTagsProps = {
    title: metaTitle,
    description: metaDescription,
    slug: `general-election-2025`,
    image: `${URL_ORIGIN}web2-assets/GE2025-page.png`,
    keywords: [
      "GE2025, Singapore Elections 2025, சிங்கப்பூர் பொதுத் தேர்தல், சிங்கப்பூர் தேர்தல் 2025, GE2025 செய்திகள், GE2025 தகவல்கள், சிங்கப்பூர் அரசியல், சிங்கப்பூர் தேர்தல் முடிவுகள், தமிழ் முரசு, சிங்கப்பூர் தேர்தல் பகுப்பாய்வு, சிங்கப்பூர் வாக்களிப்பு 2025",
    ],
    jsonLd,
  };

  const gaData: GADataProps = {
    chapter1: tagName,
    level2: "keywords",
    title: `${tagName}_Index`,
    contentcat: 1,
    contenttype: undefined,
  };

  return {
    gaData,
    metaTags,
  };
}
